module.exports = __webpack_public_path__ + "img/20190927144946580.19176d13.jpg";